export default [
  {
    path: '/my-company',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'MyCompany',
        component: () => import('./containers/MyCompanyContainer'),
      },
    ],
  },
  {
    path: '/companies',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'CompanyList',
        component: () => import('./containers/CompanyListContainer'),
        children: [
          {
            path: 'create',
            name: 'CompanyCreate',
            component: () => import('./containers/CompanyCreateContainer'),
          },
          {
            path: 'restore',
            name: 'CompanyRestore',
            component: () => import('./containers/CompanyRestoreContainer'),
          },
        ],
      },
      {
        path: ':companyId',
        props: true,
        component: () => import('./containers/CompanyContainer'),
        children: [
          {
            path: '',
            name: 'CompanyGeneral',
            component: () => import('./containers/CompanyGeneralContainer'),
            children: [
              {
                path: 'add',
                props: route => ({ ...route.query, ...route.params }),
                component: () => import('./containers/CompanyAddTokenContainer'),
              },
            ],
          },
          {
            path: 'demands',
            name: 'CompanyDemands',
            meta: { search: true },
            props: true,
            component: () => import('./containers/CompanyDemandsContainer'),
            children: [
              {
                path: 'add',
                props: route => ({ ...route.query, ...route.params }),
                component: () => import('./containers/CompanyAddTokenContainer'),
              },
              {
                path: ':demandId',
                name: 'CompanyDemand',
                props: true,
                component: () => import('./containers/CompanyDemandModalContainer'),
              },
            ],
          },
          {
            path: 'history',
            name: 'CompanyHistory',
            meta: { search: true },
            props: true,
            component: () => import('./containers/CompanyHistoryContainer'),
            children: [
              {
                path: 'add',
                props: route => ({ ...route.query, ...route.params }),
                component: () => import('./containers/CompanyAddTokenContainer'),
              },
            ],
          },
          {
            path: 'users',
            name: 'CompanyUsers',
            meta: { search: true },
            props: true,
            component: () => import('./containers/CompanyUserListContainer'),
            children: [
              {
                path: 'add',
                props: route => ({ ...route.query, ...route.params }),
                component: () => import('./containers/CompanyAddTokenContainer'),
              },
              {
                path: 'create',
                name: 'CompanyUserCreate',
                props: true,
                component: () => import('./containers/CompanyUserCreateContainer'),
              },
              {
                path: 'restore',
                name: 'CompanyUserRestore',
                props: true,
                component: () => import('./containers/CompanyUserRestoreContainer'),
              },
              {
                path: ':userId',
                name: 'CompanyUserUpdate',
                props: true,
                component: () => import('./containers/CompanyUserUpdateContainer'),
              },
            ],
          },
        ],
      },
    ],
  },
]
